import React from "react";
import Question from "../Question/question";
import "./ObjContainer.scss";
const ObjContainer = () => {
  return (
    <div className="content-border-box w-100">
      <Question type="objective" />
    </div>
  );
};

export default ObjContainer;
